import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';
import Anchor from '../Anchor';
import Column from '../Column';
import Row from '../Row';
import Theme from '../../theme';
import IconAvatarDesktop from '../../assets/svgs/header/login.svg';
import IconAvatarMobile from '../../assets/svgs/header/mobile-login.svg';
var AvatarContainer = styled.div.withConfig({
  displayName: "Avatar__AvatarContainer",
  componentId: "sc-1n42xoh-0"
})(["position:relative;"]);
var SCCenteredAnchor = styled(Anchor).withConfig({
  displayName: "Avatar__SCCenteredAnchor",
  componentId: "sc-1n42xoh-1"
})(["display:flex;align-items:center;"]);
var AvatarMenuContainer = styled.div.withConfig({
  displayName: "Avatar__AvatarMenuContainer",
  componentId: "sc-1n42xoh-2"
})(["top:", ";", ";right:", ";width:", ";border:2px solid ", ";margin-top:", ";border-radius:3px;box-shadow:0 -5px 5px -3px ", ";position:absolute;z-index:9999;overflow-x:visible;&::before{position:absolute;width:0;height:0;content:'';border-style:solid;border-color:transparent transparent ", " transparent;border-width:0 10px 10px 10px;right:20px;top:-10px;}"], remCalc(24), Theme.media.lg(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  top: ", ";\n  "])), remCalc(40)), remCalc(-15), remCalc(180), Theme.colours.grey_e5, remCalc(12), Theme.colours.grey_e5, Theme.colours.grey_e5);
var AvatarMenuList = styled.ul.withConfig({
  displayName: "Avatar__AvatarMenuList",
  componentId: "sc-1n42xoh-3"
})(["z-index:10;border-radius:1px;list-style-type:none;margin:0;display:block;background:", ";overflow:hidden;padding-left:0;&::before{content:'';position:absolute;width:0;height:0;border-style:solid;border-color:transparent transparent ", " transparent;border-width:0 8px 8px 8px;right:22px;top:-8px;}"], Theme.colours.white, Theme.colours.white);
var AvatarMenuListItem = styled.li.withConfig({
  displayName: "Avatar__AvatarMenuListItem",
  componentId: "sc-1n42xoh-4"
})(["margin:0;padding:0;&:hover{background:", ";}"], Theme.colours.grey_f5);
var AvatarMenuListItemAnchor = styled(Anchor).withConfig({
  displayName: "Avatar__AvatarMenuListItemAnchor",
  componentId: "sc-1n42xoh-5"
})(["padding:", " ", ";display:block;color:", ";text-decoration:none;&:not([disabled]):hover{color:", ";}"], remCalc(9), remCalc(20), Theme.colours.black, Theme.colours.black);
var SCIconAvatarMobile = styled(IconAvatarMobile).withConfig({
  displayName: "Avatar__SCIconAvatarMobile",
  componentId: "sc-1n42xoh-6"
})(["vertical-align:middle;"]);
var SCIconAvatarDesktop = styled(IconAvatarDesktop).withConfig({
  displayName: "Avatar__SCIconAvatarDesktop",
  componentId: "sc-1n42xoh-7"
})(["vertical-align:middle;"]);

var Avatar = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Avatar, _React$PureComponent);

  function Avatar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isMenuOpen: false
    };

    _this.handleClick = function () {
      _this.setState(function (prevState) {
        return {
          isMenuOpen: !prevState.isMenuOpen
        };
      });
    };

    return _this;
  }

  var _proto = Avatar.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        baseUrl = _this$props.baseUrl,
        menu = _this$props.menu;
    var isMenuOpen = this.state.isMenuOpen;
    return /*#__PURE__*/React.createElement(AvatarContainer, null, /*#__PURE__*/React.createElement(SCCenteredAnchor, {
      onClick: this.handleClick
    }, /*#__PURE__*/React.createElement(Row, {
      middle: "sm"
    }, /*#__PURE__*/React.createElement(Column, {
      sm: 12,
      lg: false
    }, /*#__PURE__*/React.createElement(SCIconAvatarMobile, {
      size: 24
    })), /*#__PURE__*/React.createElement(Column, {
      sm: false,
      lg: 12
    }, /*#__PURE__*/React.createElement(SCIconAvatarDesktop, {
      size: 40
    })))), isMenuOpen && /*#__PURE__*/React.createElement(AvatarMenuContainer, null, /*#__PURE__*/React.createElement(AvatarMenuList, null, menu.map(function (menu, key) {
      return /*#__PURE__*/React.createElement(AvatarMenuListItem, {
        key: key
      }, /*#__PURE__*/React.createElement(AvatarMenuListItemAnchor, {
        secondary: true,
        onClick: menu.onClick,
        href: "" + baseUrl + menu.href
      }, menu.title));
    }))));
  };

  return Avatar;
}(React.PureComponent);

export default Avatar;